import React, { useCallback, useEffect, useRef, useState } from "react";
import './projGalleryGrid.css';
import { imageSizingMapping } from "../../globals/variables";
import { AnimatePresence } from "framer-motion";
import { galControlVariants, galControlWrapVariants } from "./variants";
import { motion } from "framer-motion";
import debounce from "lodash.debounce";
import { smoothScrollTo } from "../../globals/helpers";
import { primaryInput } from "detect-it";


const ProjGalleryGrid = ({data, scroller, touchScrollerRef}) => {
    const [numRows, setNumRows] = useState(null);
    const [addLogo, setAddLogo] = useState(false);
    const entriesPerRow = 3;
    const [lastRowCenter, setLastRowCenter] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [srcType, setSrcType] = useState(null);
    const [isGalExpanded, setIsGalExpanded] = useState(false);
    const galImgRefs = useRef([]);
    const imgRefs = useRef([]);
    const hiderRef = useRef(null);
    const [clickTimeout, setClickTimeout] = useState(false);
    const [currentlExpandedidx, setCurrentlyExpandedIdx] = useState(null);
    const galWrapperRef = useRef(null);

    const responsiveBehaviour = () => {
        let tmpWidth = window.innerWidth;
        let splitWidth = tmpWidth;
        let targetSrcType = null;
        Object.entries(imageSizingMapping).forEach(([key, value]) => {
            if(splitWidth>= value[0] && splitWidth < value[1]){
                targetSrcType = key;
            }
        });
        setSrcType(targetSrcType)
    }

    useEffect(() => {
        if(srcType !== null){
            let length = data.stills.length;
            let lastRowRemaining = length % entriesPerRow;
            let numberOfRows = Math.ceil(length/entriesPerRow);
    
            setNumRows(numberOfRows);
            setLastRowCenter(lastRowRemaining == 1);
            let tmpRes = [];
            let endpoint;
            if(lastRowRemaining == 1) endpoint = ((numberOfRows-1)*entriesPerRow);
            else endpoint = numberOfRows*entriesPerRow;
    
            for(let i = 0; i<endpoint; i++){
                if(data.stills[i]){
                    let tmpSrc = data.stills[i].backgroundImage;
                    let renamedSrc = tmpSrc.replace('mobile', srcType);
                    tmpRes.push(renamedSrc)
                } else{
                    tmpRes.push("ignore");
                    setAddLogo(true);
                }
            }
            if(lastRowRemaining == 1){
                tmpRes.push("ignore")
                let tmpSrc = data.stills[data.stills.length-1].backgroundImage;
                let renamedSrc = tmpSrc.replace('mobile', srcType);
                tmpRes.push(renamedSrc)
                tmpRes.push("ignore")
            }
            setRowData(tmpRes);
        }
    }, [srcType])

    const debounceClicking = useCallback(
        debounce(() => {
            setClickTimeout(false)
        }, 650),
        []
    );

    const centerGallery = () => {
        
    }
    
    const openGallery = (idx, isControlled) => {
        if(!clickTimeout){
            try{
                scroller.stop();
            } catch{
                if(primaryInput == "touch"){
                    try{
                        touchScrollerRef.current.style.overflow = "hidden"
                    } catch{}
                } else{
                    try{
                        scroller.stop()
                    } catch{}
                }
            }
            
            try{
                let wrapperY;
                let wrapperBounding = galWrapperRef.current.getBoundingClientRect();
                wrapperY = wrapperBounding.y;

                let targHeight = wrapperBounding.height;
                let windowHeight = window.innerHeight;
                let targetYVal = (windowHeight/2) - (targHeight/2);
                let scrollDelta = targetYVal - wrapperY;
                
                let timeoutFrac = scrollDelta/(window.innerHeight/2);
                let stopTimeout = Math.max(Math.abs(timeoutFrac * 750), 400);
                let scrollToVal;
                
                let scrollOffset;
                if(primaryInput == "touch"){
                    scrollOffset = touchScrollerRef.current.scrollTop;
                }else{
                    scrollOffset = scroller.scroll.instance.scroll.y;
                }
                scrollToVal = scrollOffset + (-1 * scrollDelta);
                
                galImgRefs.current[idx].style.pointerEvents = "none";
                if(Math.abs(scrollDelta) > window.innerHeight/20){
                    if(primaryInput == "touch"){
                        smoothScrollTo(touchScrollerRef.current,
                            0,
                            scrollToVal,
                            stopTimeout,
                            [0.16, 1, 0.3, 1]
                        )
                    }else{
                        scroller.scrollTo( 'top', {
                            'offset': scrollToVal,
                            'callback': function() {
                            },
                            'duration': stopTimeout,
                            'easing':   [0.16, 1, 0.3, 1],
                            'disableLerp': false
                        } );
                    }
                } else{
                    stopTimeout = 0;
                }
               

                setTimeout(() => {
                    let target = galImgRefs.current[idx];
                let targBounding = target.getBoundingClientRect();
                let xPos = targBounding.x;
                let yPos = targBounding.y
                let eleWidth = targBounding.width;
                let windowWidth = window.innerWidth;
                let eleHeight = targBounding.height;
                let windowHeight = window.innerHeight;
                let windowCenter = [(windowWidth/2) - (eleWidth/2), (windowHeight/2) - (eleHeight/2)];
                let eleXDelta = windowCenter[0] - xPos;
                let eleYDelta = windowCenter[1] - yPos;

                let translateString = `translate3d(${eleXDelta}px, ${eleYDelta}px, 0)`;


                let maxScale = Math.min((windowHeight-120)/eleHeight, (windowWidth-140)/eleWidth)
                let scaleString = `scale3d(${maxScale}, ${maxScale}, 1)`
                target.style.transform = translateString + " " + scaleString;
                imgRefs.current[idx].style.border = "0.5px solid white";
                if(isControlled)
                    target.style.transitionDuration = "0.95s"
                else
                    target.style.transitionDuration = null
                target.style.zIndex = 1 
                if(!isGalExpanded){
                    if(isControlled) target.style.transitionDelay = "0.125s";
                    else target.style.transitionDelay = "0.25s";
                }
                else target.style.transitionDelay = "0s";
                for(let i = 0; i<galImgRefs.current.length; i++){
                    
                    if (i !== idx){
                        try{
                            galImgRefs.current[i].style.zIndex = 0;
                        }catch{}
                    }
                }
                hiderRef.current.style.background = "rgba(0,0,0,0.25)";
                hiderRef.current.style.opacity = 1;
                hiderRef.current.style.backdropFilter = "blur(3px) grayscale(1)"
                hiderRef.current.style.transitionDelay = "0s";                
                setIsGalExpanded(true);
                setClickTimeout(true);
                debounceClicking();
                setCurrentlyExpandedIdx(idx)
                }, stopTimeout)
                
            } catch{}
        }
    }

    const closeGallery = (isControlled, isFinalExit) => {
        if(!clickTimeout){
            try{
                let targEle = galImgRefs.current[currentlExpandedidx];
                galImgRefs.current[currentlExpandedidx].style.pointerEvents = "all";
                if(isControlled)
                    targEle.style.transitionDuration = "0.95s"
                else
                    targEle.style.transitionDuration = null
                targEle.style.transform = "translate3d(0,0,0) scale3d(1, 1, 1)";
                imgRefs.current[currentlExpandedidx].style.border = "0.5px solid transparent";
                
                hiderRef.current.style.opacity = 0;
                hiderRef.current.style.transitionDelay = "0.5s";

                setCurrentlyExpandedIdx(null);
                setIsGalExpanded(false);
                setClickTimeout(true);
                debounceClicking();
                if(isFinalExit){
                    try{
                        scroller.start();
                    } catch{
                        try{
                            touchScrollerRef.current.style.overflow = "scroll"
                        } catch{}
                    }
                }
            }catch{

            }
        }
    }

    const handleItemClick = (idx) => {
        if(galImgRefs.current){
            if(galImgRefs.current[idx]){
                if(!isGalExpanded){
                    openGallery(idx)
                } else{
                    closeGallery(false, true)
                }
                
                
            }
        }
    }

    const handleGalClick = () => {
        if(isGalExpanded){
            closeGallery(false, true);
        }
    }

    const nextClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let nextIdx = currentlExpandedidx + 1;
        closeGallery(true, false);
        if(nextIdx > galImgRefs.current.length - 1)
            nextIdx = 0;
        setTimeout(() => {
            openGallery(nextIdx, true)
        }, 900)
    }

    const previousClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let prevIdx = currentlExpandedidx - 1;
        closeGallery(true, false);
        if(prevIdx < 0)
            prevIdx = galImgRefs.current.length - 1
        setTimeout(() => {
            openGallery(prevIdx, true)
        }, 1000)
    }

    useEffect(() => {
        responsiveBehaviour()
        window.addEventListener('resize', responsiveBehaviour)
        
    }, [])
    return(
        <>
            
            <div className="project_gallery_grid__wrapper" onClick={handleGalClick} ref={galWrapperRef}>
                <div className="proj_mini_section__wrapper">
                    <span>GALLERY</span>
                </div>
                <div className="gal_expander" ref={hiderRef}/>
                <AnimatePresence>
                {
                    isGalExpanded &&
                    <motion.div 
                        className="gal_expand_controls"
                        initial="initial"    
                        animate="animate"    
                        exit="exit"    
                        variants={galControlWrapVariants}
                    >
                        <motion.div 
                            className="prev-img__wrapper" variants={galControlVariants}
                            onClick={(e) => previousClick(e)}
                            onMouseEnter={(e) => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.add("cursor-active")
                                }
                                catch{

                                }
                            }}
                            onMouseLeave={(e) => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.remove("cursor-active")
                                }
                                catch{

                                }
                            }}    
                        >
                            <span>PREV <div className="box-hov-indicator"> 
                                                    <span className="bx-h bx-tl"></span>
                                            <span className="bx-h bx-tr"></span>
                                            <span className="bx-h bx-bl"></span>
                                            <span className="bx-h bx-br"></span>

                                            <span className="bx-v bx-tl"></span>
                                            <span className="bx-v bx-tr"></span>
                                            <span className="bx-v bx-bl"></span>
                                            <span className="bx-v bx-br"></span>
                                        </div></span>
                        </motion.div>
                        <motion.div className="gal-close__wrapper" variants={galControlVariants}
                            onMouseEnter={(e) => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.add("cursor-active")
                                }
                                catch{

                                }
                            }}
                            onMouseLeave={(e) => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.remove("cursor-active")
                                }
                                catch{

                                }
                            }}
                        >
                            <span>CLOSE
                                <div className="box-hov-indicator"> 
                                                    <span className="bx-h bx-tl"></span>
                                            <span className="bx-h bx-tr"></span>
                                            <span className="bx-h bx-bl"></span>
                                            <span className="bx-h bx-br"></span>

                                            <span className="bx-v bx-tl"></span>
                                            <span className="bx-v bx-tr"></span>
                                            <span className="bx-v bx-bl"></span>
                                            <span className="bx-v bx-br"></span>
                                        </div>
                            </span>
                        </motion.div>
                        <motion.div 
                            className="next-img__wrapper"
                            variants={galControlVariants}
                            onClick={(e) => {nextClick(e)}}
                            onMouseEnter={(e) => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.add("cursor-active")
                                }
                                catch{

                                }
                            }}
                            onMouseLeave={(e) => {
                                try{
                                    let test = document.getElementById('cursor-circle');
                                    test.classList.remove("cursor-active")
                                }
                                catch{

                                }
                            }}
                        >
                            <span>NEXT <div className="box-hov-indicator"> 
                                                    <span className="bx-h bx-tl"></span>
                                            <span className="bx-h bx-tr"></span>
                                            <span className="bx-h bx-bl"></span>
                                            <span className="bx-h bx-br"></span>

                                            <span className="bx-v bx-tl"></span>
                                            <span className="bx-v bx-tr"></span>
                                            <span className="bx-v bx-bl"></span>
                                            <span className="bx-v bx-br"></span>
                                        </div></span>
                        </motion.div>
                    </motion.div>
                }
                </AnimatePresence>
                {
                    rowData !== null && Array.from({ length: numRows }).map((row, r_idx) => (
                        <div 
                            className="proj_grid__row"    
                        > 
                            {
                                rowData.slice(r_idx * entriesPerRow, (r_idx*entriesPerRow) + entriesPerRow).map((still, s_idx) => (
                                    still !== "ignore" ?
                                        <div 
                                            className="proj_grid_still__wrapper"
                                            ref={el => galImgRefs.current[(r_idx * entriesPerRow )+ s_idx] = el}
                                            onClick={() => {handleItemClick((r_idx * entriesPerRow )+ s_idx)}}
                                            onMouseEnter={(e) => {
                                                try{
                                                    let test = document.getElementById('cursor-circle');
                                                    test.classList.add("cursor-active")
                                                }
                                                catch{

                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                try{
                                                    let test = document.getElementById('cursor-circle');
                                                    test.classList.remove("cursor-active")
                                                }
                                                catch{

                                                }
                                            }}
                                        >
                                            <div>
                                                <img src={still} ref={el => imgRefs.current[(r_idx * entriesPerRow )+ s_idx] = el} />
                                            </div>
                                        </div>
                                    : 
                                        (s_idx == entriesPerRow - 1  && addLogo) ?
                                            <div className="proj_grid_empty__wrapper">
                                                <img
                                                    style={{
                                                        opacity: 0,
                                                        width: "100%",
                                                        height: "auto",
                                                        objectFit: "contain"
                                                    }}
                                                    src={rowData[s_idx-1]} />
                                                    <svg 
                                                        style={{
                                                            position: "absolute",
                                                            maxWidth: "45%",
                                                            height: "auto",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)"
                                                        }}
                                                    xmlns="http://www.w3.org/2000/svg" width="815" height="233" viewBox="0 0 815 233" fill="none">
                                                        <path d="M529.988 12.2081C529.455 5.84812 535.908 1.59482 541.521 0.701488C553.948 -0.591845 566.481 0.341457 578.948 0.128124C588.255 0.221457 598.068 -1.00521 606.828 2.91479C613.721 5.82145 618.135 12.1281 623.295 17.2348C641.041 35.1948 657.735 54.2615 676.761 70.9015C671.615 50.5548 663.668 31.0348 658.335 10.7415C657.708 4.64815 664.175 0.728145 669.521 0.274812C684.255 -0.0585215 699.001 -0.0851816 713.721 0.448152C719.321 0.501485 725.241 3.62146 727.081 9.16812C755.068 79.0081 784.921 148.075 814.095 217.421C814.855 221.115 812.535 224.688 809.615 226.768C804.348 230.675 797.228 231.101 791.015 229.608C775.388 225.901 759.761 222.141 744.268 217.928C737.441 216.048 730.241 214.821 724.188 210.928C715.561 205.555 709.281 197.381 702.361 190.101C685.215 172.101 668.241 153.942 651.428 135.635C639.895 123.528 629.455 110.408 617.268 98.9548C617.375 101.248 617.628 103.528 618.001 105.821C622.588 127.515 628.095 149.008 632.281 170.795C633.308 175.168 628.975 178.528 625.135 179.328C620.695 180.635 616.268 178.875 612.095 177.515C594.375 171.848 576.868 165.515 559.201 159.728C554.148 157.995 549.055 154.101 548.548 148.421C542.068 103.061 535.521 57.7015 529.988 12.2081Z" fill="white"/>
                                                        <path d="M98.253 5.18111C102.32 3.72777 106.68 3.92777 110.933 3.92777C162.04 3.48777 213.16 3.91443 264.266 3.75443C270.72 3.7011 278.64 6.48779 280.466 13.3678C279.306 24.5678 276.813 35.5811 274.866 46.6611C269.24 80.9678 263.64 115.274 258.786 149.714C257.84 156.354 251.64 160.634 245.733 162.688C173.666 188.208 100.933 211.981 27.0396 231.674C20.3596 233.421 13.0263 233.061 6.7463 230.074C2.11963 228.008 -0.947036 222.554 0.266297 217.554C23.5996 148.968 53.2663 82.7678 84.0796 17.2878C86.4663 11.2078 92.173 7.06111 98.253 5.18111ZM150.106 40.9678C145.693 41.9011 143.386 46.3278 142.013 50.2078C132.826 75.8078 123.733 101.448 115.2 127.288C112.826 134.661 109.72 141.981 109.44 149.848C112.52 150.088 115.68 150.341 118.68 149.408C135.453 144.808 152.106 139.728 168.52 133.954C174.426 132.168 180.853 129.381 183.573 123.421C188.946 111.648 190.306 98.6078 193.973 86.3011C197.506 71.3544 202.306 56.6878 204.546 41.4744C194.786 39.3678 184.773 40.5411 174.906 40.3144C166.64 40.2344 158.293 39.5411 150.106 40.9678Z" fill="white"/>
                                                        <path d="M322.107 6.24822C326.213 4.80822 330.627 5.06157 334.893 5.00823C383.373 4.86157 431.84 4.9549 480.307 4.92824C486.44 4.7549 493.6 8.12822 495.04 14.5816C497.093 27.5016 497.6 40.6082 499.267 53.5682C502.8 83.3149 506.053 113.088 509.653 142.822C511.093 151.808 501.973 158.982 493.64 159.022C433.64 159.848 373.613 159.662 313.613 158.795C305.813 158.435 294.253 155.155 294.48 145.528C299.373 102.502 304.933 59.5149 311.88 16.7549C312.507 11.4082 317.32 7.80822 322.107 6.24822ZM372.867 50.7816C372.027 70.4349 369.493 90.0349 370.293 109.728C373.733 111.782 377.387 113.995 381.533 114.088C394 114.555 406.48 114.848 418.96 114.702C424.173 114.648 429.427 113.928 434.307 111.982C435.653 101.368 434.067 90.7016 433.88 80.0749C433.2 67.5416 433.893 54.8882 431.773 42.4749C424.347 39.3282 416.147 39.9682 408.28 39.9149C398.44 39.9949 388.533 39.1282 378.76 40.5949C374.227 41.5149 373.187 46.8883 372.867 50.7816Z" fill="white"/>
                                                        <path d="M291.734 226.275C292.908 214.329 294.161 202.395 296.001 190.542C307.681 190.529 319.361 190.382 331.041 190.595C334.588 190.515 337.854 193.849 337.534 197.435C337.374 202.155 337.174 206.889 336.534 211.582C336.268 214.329 333.708 216.675 330.948 216.715C322.854 217.062 314.734 216.755 306.628 216.862C306.308 219.982 305.961 223.102 305.601 226.249C300.974 226.395 296.361 226.409 291.734 226.275ZM308.068 200.889C307.961 202.209 307.774 204.849 307.681 206.182C313.054 206.182 318.441 206.195 323.828 206.035C323.921 204.729 324.081 202.115 324.174 200.809C318.801 200.809 313.428 200.809 308.068 200.889Z" fill="white"/>
                                                        <path d="M352.773 225.608C352.947 214.088 353.547 202.568 354.52 191.088C364.853 189.675 375.28 190.968 385.667 190.421C389.733 190.021 394.747 192.008 395.707 196.381C396.227 202.008 396.187 207.741 395.667 213.381C394.613 215.275 392.48 216.101 390.773 217.261C392.72 220.061 394.453 223.021 395.773 226.168C391.467 226.408 387.147 226.368 382.827 226.408C380.653 223.275 378.6 220.075 376.547 216.861C373.12 216.835 369.707 216.848 366.293 216.888C366.187 219.955 366.053 223.035 365.92 226.115C361.547 226.195 357 227.221 352.773 225.608ZM367.027 200.781C366.88 202.568 366.773 204.368 366.707 206.168C372.093 206.181 377.493 206.168 382.893 206.181C382.893 204.381 382.92 202.595 382.96 200.821C377.64 200.808 372.333 200.848 367.027 200.781Z" fill="white"/>
                                                        <path d="M413.787 191.168C422.52 189.741 431.493 190.808 440.333 190.501C444.787 190.088 449.507 193.515 449.773 198.128C450.373 205.501 450.72 212.901 451.16 220.288C451.693 223.141 449.36 226.101 446.467 226.235C437.72 226.555 428.947 226.368 420.2 226.341C415.573 226.541 411.32 222.381 411.427 217.755C411.173 210.528 411.08 203.288 411.107 196.061C410.893 194.048 412.08 192.128 413.787 191.168ZM424.28 200.821C424.373 205.688 424.48 210.568 424.56 215.461C428.92 215.461 433.28 215.501 437.654 215.475C437.36 210.581 437.107 205.701 436.907 200.808C432.693 200.821 428.48 200.808 424.28 200.821Z" fill="white"/>
                                                        <path d="M465.879 190.755C477.359 190.408 488.839 190.262 500.319 190.742C505.266 190.902 508.266 195.928 508.732 200.395C509.106 206.582 510.372 212.702 510.612 218.915C510.639 222.995 506.692 226.262 502.786 226.368C491.319 226.368 479.852 226.502 468.399 226.222C467.492 214.408 466.186 202.608 465.879 190.755ZM479.426 200.822C479.892 205.702 480.372 210.595 480.852 215.488C486.266 215.488 491.679 215.488 497.092 215.488C496.572 210.608 496.026 205.728 495.532 200.862C490.159 200.822 484.786 200.808 479.426 200.822Z" fill="white"/>
                                                    </svg>
                                            </div>
                                        : 
                                            <div className="proj_grid_empty__wrapper"/>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default ProjGalleryGrid;